<template>
  <div class="add-traveller">
    <button v-if="context !== 'admin'" ref="btn" class="btn" @click="onAddTraveller" >
      <fa v-if="!btnDefault" fa-class="plus" />

      <b-tooltip :target="'tooltip-' + index + '-add'">
        {{$t('_add')}}
      </b-tooltip>
    </button>

    <b-modal v-if="isLoaded" id="traveller-add" ref="traveller-add" v-model="showModal"
             :cancel-disabled="true" :ok-disabled="true" :hide-footer="true"
             :title="$t('traveller.add.title')"
    >
      <div>
        <form-base type="traveller_add"
                   :form-data="travellerAddData"
                   :default-submit-button="false"
                   :callbacks="{ addTraveller: onConfirmAddTraveller }"
                   :unlogged-infos="unloggedInfos"
                   invoked-submit-button-name="addTraveller"
                   @error="setErrorVisible"
                   :class="context"
        >
          <b-tabs>
            <b-tab :title="$t('_general')">
              <radio-input class="mt-3" label="_gender" name="gender" :options="genderOptions"
                           v-model="travellerAddData.gender" ref="gender"
                           :submitted="trySubmit"
              />

              <text-input label="_first_name" name="first-name" ref="firstName"
                          v-model="travellerAddData.firstName"
              />

              <text-input label="_last_name" name="last-name" ref="lastName"
                          v-model="travellerAddData.lastName"
              />

              <text-input label="_mobile_phone" name="phone" ref="mobilePhone"
                          v-model="travellerAddData.phoneNumber" type="tel"
              />

              <text-input label="_email" name="email" type="email" ref="email"
                          v-model="travellerAddData.email"
              />

              <text-input label="_email2" name="email2" type="email" ref="email2"
                          v-model="travellerAddData.email2" :required="false"
              />
            </b-tab>

            <b-tab :title="$t('traveller.references')"
                   v-if="travellerAddData.companyInputFields.length"
            >
              <custom-input-controller :fields="travellerAddData.companyInputFields"
                                       :no-required-field="true"
                                       @input="onInputCustomFields"
                                       :verticalClass="true"
                                       class="mt-3"
                                       :class="context"
              />
            </b-tab>

            <div v-if="submitted" class="col-12">

              <b-alert v-if="success" variant="success" show>
                <span>{{ $t('traveller.add.alert.success') }}</span>
              </b-alert>

              <b-alert v-else-if="errors.length && !paramsExisting" variant="danger" class="col-md-8"
                       dismissible show
              >
                <ul>
                  <li v-for="error in errors" :key="error.id" class="error">
                    <span class="label">
                      {{ $t(labels[error.field]) | capitalise }} :
                    </span>

                    {{ error.msg }}
                  </li>
                </ul>
              </b-alert>
            </div>

            <div class="row justify-content-center">
              <submit-button text="_validate" name="addTraveller"
                             @click="trySubmit = true"
              />
            </div>
          </b-tabs>
        </form-base>

      </div>
    </b-modal>
  </div>
</template>

<script>
import travellerEmpty from '@/components/frontoffice/form/traveller/empty'
import formBase from '@/components/frontoffice/form/base'
import bModal from 'bootstrap-vue/es/components/modal/modal'
import textInput from '@/components/frontoffice/form/baseInput/text'
import radioInput from '@/components/frontoffice/form/baseInput/radio'
import submitButton from '@/components/frontoffice/form/baseInput/submit'
import CommonApi from '@/api/commonApi'
import customInputController from '@/components/frontoffice/form/customInput/controller'
import fa from '@/components/global/icon/fontAwesome'
import travellerExisting from '@/components/frontoffice/form/traveller/existingTravellerModal'

export default {
  components: {
    travellerEmpty,
    formBase,
    bModal,
    radioInput,
    textInput,
    submitButton,
    customInputController,
    fa,
    travellerExisting
  },

  props: {
    index: {
      type: String
    },
    text: {
      type: String,
      default () {
        return this.$t('_traveller_add')
      }
    },
    btnDefault: {
      type: Boolean,
      default: false
    },
    companyInputFields: {
      default: null
    },
    unloggedInfos: Object
  },

  data () {
    return {
      context: this.$route.matched[0].name,
      isLoaded: false,
      commonApi: new CommonApi(),
      genderOptions: [
        { value: 'male', label: '_male', selected: false },
        { value: 'female', label: '_female', selected: false }
      ],
      showModal: false,
      travellerAddData: {
        companyId: this.$route.params.id,
        gender: null,
        firstName: null,
        lastName: null,
        phoneNumber: null,
        email: null,
        email2: null,
        companyInputFields: null,
        validForm: false
      },
      submitted: false,
      success: false,
      errors: [],
      labels: {
        gender: '_gender',
        firstName: '_first_name',
        lastName: '_last_name',
        landline: '_landline',
        mobilePhone: '_mobile_phone',
        phones: '_phone_number',
        email: '_email',
        email2: '_email2',
        isManager: '_is_manager',
        enabled: '_enabled'
      },
      trySubmit: false
    }
  },

  async created () {
    if (this.context === 'admin') {
      await this.commonApi.searchCompany(this.travellerAddData.companyId).then(response => {
        if (response.status === 200) {
          this.travellerAddData.companyInputFields = this.clone(response.data.data.booking_input_fields)
        }
      })
    } else {
      this.travellerAddData.companyInputFields = this.clone(this.companyInputFields !== null ? this.companyInputFields : this.$store.getters['security/company'].inputFields)
    }
    this.isLoaded = true
  },

  mounted () {
    if (this.context !== 'admin') {
      let btn = this.$refs.btn
      btn.className = this.getBtnClass()

      if (this.btnDefault) {
        btn.innerText = this.text
      } else {
        btn.title = this.text
      }
    }
  },

  methods: {
    clone (x) {
      return JSON.parse(JSON.stringify(x))
    },

    setErrorVisible (errors) {
      this.submitted = true
      errors.forEach(error => {
        if (error) {
          this.success = false
          this.errors = errors
        }
      })
    },

    onAddTraveller () {
      this.showModal = !this.showModal
    },

    onConfirmAddTraveller (data) {
      if (data) {
        this.success = true
        this.submitted = true

        setTimeout(() => {
          this.showModal = false
          this.submitted = false
          this.$emit('input', data)
        }, 3000)
      } else {
        this.success = false
      }
    },

    onInputCustomFields (newVal) {
      this.travellerAddData.companyInputFields.map(function (inputField) {
        if (inputField.id === newVal.id) {
          inputField.value = newVal.value
        }
      })
    },

    getBtnClass () {
      return this.btnDefault ? 'orange-white btn' : 'btn'
    }
  }
}
</script>
<style scoped>
.admin form .custom-input:not(.dates){
  border-bottom: none;
  margin-right: 1rem;
}

.admin form .custom-input {
  border-bottom: none;
  margin-top: 0;
  height: 90px;
}

.admin .input-inner{
  border-bottom: none;
}

</style>
